<template>
  <div v-infinite-scroll="loadMore" :infinite-scroll-disabled="fancyBusy" :infinite-scroll-throttle-delay="300" :infinite-scroll-distance="200" class="container fancy-container">
    <template v-if="personIsAdmin">
      <div class="fancy-container-wrap">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <h3>Модерация новых загруженных картинок</h3>
            <div class="switcher">
              <div v-for="cat in tags" class="switcher-link"">
                <router-link :to="`/moderate/${cat.tag}/`" :class="['switcher-link-a', {'switcher-link-a-active': cat.tag === $route.params.category}]">{{ cat.name }}</router-link>
              </div>
            </div>
          </div>
          <div v-if="fancyList && fancyList.length" v-for="fancy, key in fancyList" :class="`fancy ${fancy.tags[0] && fancy.tags[0].slug && fancy.tags[0].slug.indexOf('web') > -1 ? 'col-md-11' : 'col-md-5'}`">
            <span @click="deleteRef(fancy, key)" class="fancy-delete">
              <img src="/static/icon-delete.svg"/>
            </span>
            <span class="fancy-number">№ {{ key + 1 }}</span>
            <div class="fancy-image">
              <img :src="fancy.image"/>
            </div>
            <div class="fancy-tags-wrap">
              <select @change="updateTag(fancy, key, $event)" class="fancy-tags">
                <option v-for="tg in tags" :selected="checkCurrentTag(fancy, tg)" :value="tg.value">{{tg.name}}</option>
              </select>
            </div>
            <div class="fancy-rate">
              <div @click="approveRef(fancy, false, key)" class="fancy-rate-down">
                <svg width="39" height="37" viewBox="0 0 39 37"><path transform="translate(0, 16)" d="M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"></path> <path transform="translate(11, 0)" d="M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"></path></svg>
              </div>
              <div @click="approveRef(fancy, true, key)" class="fancy-rate-up">
                <svg width="39" height="37" viewBox="0 0 39 37"><path transform="translate(0, 16)" d="M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"></path> <path transform="translate(11, 0)" d="M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"></path></svg>
              </div>
            </div>
          </div>

          <div v-if="fancyList && fancyList.length" class="col-md-11 fancy-delete-all">
            <button @click="deleteAll()">Удалить все картинки без оценок</button>
          </div>
        </div>
      </div>
      <div v-if="(!fancyList || fancyList.length <= 0) && !fancyBusy" class="row">
        <div class="col-md-12 fancy-empty">
          <p>Новых картинок без оценок нет. Вернуться на <router-link to='/'>главную</router-link></p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';

import findObj from '@/utils/objects';

import RateIndicator from '@/components/Rate/Indicator';
import RateButton from '@/components/Rate/Button';

export default {
  components: {
    RateIndicator,
    RateButton,
  },

  computed: mapGetters({
    personIsAdmin: 'personIsAdmin',
    fancyDeleted: 'fancyDeleted',
    fancyInfo: 'fancyInfo',
    fancyList: 'fancyList',
    fancyBusy: 'fancyBusy',
    tags: 'tags',
  }),

  watch: {
    $route() {
      this.loadNew();
    },
  },

  mounted() {
    this.loadNew();
  },

  methods: {
    loadNew() {
      this.$store.commit('CLEAR_FANCY_LIST');
      this.loadMore();
    },

    loadMore() {
      if (!this.fancyBusy) {
        this.$store.dispatch('fetchFancyList', this.$route.params.category);
      }
    },

    checkCurrentTag(fancy, tg) {
      const hasTag = fancy.tags && fancy.tags[0];
      if (hasTag) {
        const isActiveTemp = fancy.tags[0].value === tg.value;
        const isActiveStandard = fancy.tags[0].slug === tg.tag;
        return isActiveTemp || isActiveStandard;
      }
      return false;
    },

    approveRef(fancy, dir, key) {
      const tagCurrent = fancy.tags && fancy.tags[0] ? fancy.tags[0] : null;
      if (tagCurrent) {
        const tag = tagCurrent.value ? tagCurrent : this.getCurrenTag(tagCurrent);
        const data = {
          estimation: dir ? 500 : 100,
          id: fancy.id,
          tags: tag.value,
          number: key,
        };
        this.$store.dispatch('approveFancy', data);
      }
    },

    getCurrenTag(tagCurrent) {
      return findObj(this.tags, tagCurrent.slug, 'tag');
    },

    getCurrenTagByVal(value) {
      return findObj(this.tags, Number(value), 'value');
    },

    updateTag(fancy, number, e) {
      const data = {
        key: number,
        tag: this.getCurrenTagByVal(e.target.value),
      };
      this.$store.commit(types.TAG_FANCY_UPDATE, data);
    },

    deleteRef(data, key) {
      const params = data;
      params.number = key;
      this.$store.dispatch('deleteFancy', params);
    },

    deleteAll() {
      this.$store.commit(types.DELETED_FANCY_LIST, this.fancyList.length);
      for (let ref = 0; ref < this.fancyList.length; ref += 1) {
        this.$store.dispatch('deleteAllFancies', this.fancyList[ref]);
      }
      this.$store.commit('CLEAR_FANCY_LIST');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.fancy{
  border: solid 1px #f1f1f1;
  border-radius: 5px;
  position: relative;
  font-size: 80%;
  padding: 0;
  margin: 3%;

  &-image{
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
    
  img{
    max-width: 100%;
    height: auto;
  }

  &-container{
    max-width: 1360px;
    margin-top: 40px;
    margin: 0 auto;
    width: 100%;

    &-wrap{
      text-align: center;
      padding: 0 35px;
    }
  }
  &-number{
    padding: 8px 8px 4px;
    position: absolute;
    background: white;
    right: 31px;
    top: 0;
  }

  &-delete{
    background: rgba(255,255,255,1);
    /*f*/
    position: absolute;
    text-align: center;
    cursor: pointer;
    padding: 6px;
    width: 34px;
    right: 0;
    top: 0;

    img{
      transition: all .3s ease-in-out;
      transform-origin: center center;
      max-height: 15px;
      max-width: 15px;
    }

    &:hover{
      img{
        transform: scale(1.2);
      }
    }
  }

  &-tags{
    background: transparent;
    border-radius: 0;
    font-size: 100%;
    height: 25px;
    border: 0;
    top: 0;
    
    &-wrap{
      background: rgba(255,255,255,1);
      transition: all .3s ease-in-out;
      position: absolute;
      padding: 3px 0 0px;
      left: 0;
      top: 0;
      &:hover{
        background: white;
      }
    }
  }

  &-rate{
    transition: all .3s ease-in-out;
    white-space: nowrap;
    position: relative;
    text-align: center;
    display: flex;
    padding: 0;
    width: 100%;
    /*opacity: 0;*/
    bottom: 0;
    left: 0;

    &-down,
    &-up{
      transition: all .3s ease-in-out;
      background: #bbb;
      cursor: pointer;
      padding: 10px 0;
      width: 50%;
      margin: 0;

      svg {
        transition: all .3s ease-in-out;
        width: 20px;
        fill: white;
      }
      &:hover{
        svg {
          transform: scale(1.2);
        }
      }
    }
    &-up{
      border-left: solid 1px white;
      &:hover{
        background: #09ca7a;
      }
    }
    &-down{
      transform: rotateZ(180deg);
      &:hover{
        background: #ca280e;
      }
      svg{
        position: relative;
        top: 2px;
      }
    }
  }

  &-empty{
    text-align: center;
    padding: 70px;
  }

  &:hover{
    .fancy-rate{
      opacity: 1;
    }
  }

  &-delete-all{
    margin: 100px 1.75% 100px;

    button{
      background: #cc1818;
      padding: 30px 60px;
      border-radius: 0;
      font-size: 130%;
      width: 100%;

      &:hover{
        background: #de4e37;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// Moderation.vue?65084767